import React, {useEffect, useState} from "react";
import {
    Card,
    CardContent,
    Typography,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Button,
    Chip,
    CardHeader,
    Box,
    TextField,
    ImageList,
    ImageListItem,
    CardActionArea,
    Stepper,
    Step,
    StepLabel,
    StepContent,
    CardActions, InputAdornment, IconButton, Tooltip,
} from "@mui/material";
import Divider from "@mui/material/Divider";
import DropzoneImage from "../../../components/DropzoneImage";
import {Assistant, Camera, CameraAlt, Create} from "@mui/icons-material";
import {getCondoId} from "../../../services/Main/AuthStorage";
import {api} from "../../../services/Main/Api";
import {useParams} from "react-router-dom";
import moment from 'moment/moment'
import StreamViewer from "../../../components/StreamViewer";
import CollectionsIcon from '@mui/icons-material/Collections';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import {id} from "date-fns/locale";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    };
}

const InspectionDetails = () => {

    const [data, setData] = useState(null);
    const [images, setImages] = useState([]);
    const [open, setOpen] = useState(false);
    const [manual, setManual] = useState(false);
    const params = useParams()
    const [value, setValue] = useState(0);
    const [description, setDescription] = useState("");

    const handleChange = (event, newValue) => {
        console.log(newValue, "NewValue")
        setValue(newValue);
    };

    function getInspection(){
        const condo_id= getCondoId()
        api.get(`/property-inspection/${params.id}/?condo_id=${condo_id}`).then(response => {
            const {data} = response
            setData(data)
        }).catch(error => {
            console.log(error)
        })
    }

    useEffect(() => {
        getInspection()
    }, []);

    useEffect(() => {
        getInspection()
    }, [images]);

    async function uploadImages(files, characteristic_id) {
        try {
            const formData = new FormData();

            // Adiciona cada arquivo com o mesmo nome de campo 'image'
            files.forEach(file => {
                formData.append('image', file);
            });

            formData.append("characteristic", characteristic_id);

            const response = await api.post('/property-inspection/characteristic/images/', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            console.log(response?.data);
            setImages(response?.data);
        } catch (error) {
            console.error(error);
        }
    }
    const handleUploadComplete = (uploadedImages) => {
        console.log('Upload completo:', uploadedImages);
        setImages(uploadedImages);
    };

    const [activeStep, setActiveStep] = useState(0);

    function  handleSaveCharacteristic(id) {
        const data = {
            description: description,
        }
        api.post(`/property-inspection/characteristic/${id}/`, data).then(response => {
            console.log(response)
        }).catch(error => {
            console.log(error)
        })
    }

    const handleNext = () => {
        const id = data?.characteristic[activeStep]?.id
        //handleSaveCharacteristic(id)
        setActiveStep(activeStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    useEffect(() => {

    }, [activeStep]);

    return (
        <Grid container spacing={2} padding={2}>
            <Grid item xs={12} md={3}>
                <Card elevation={3} sx={{ p: 2 }}>
                    <Stepper activeStep={activeStep} orientation="vertical">
                        {data?.characteristic.map((characteristic, index) => (
                            <Step key={index}>
                                <StepLabel
                                    onClick={() => setActiveStep(index)}
                                    sx={{ cursor: 'pointer' }}
                                    // optional={
                                    //         <Typography variant="caption">Adicione a descrição </Typography>
                                    // }
                                >
                                    {characteristic.name}

                                </StepLabel>
                                {/* Removemos o StepContent aqui */}
                            </Step>
                        ))}

                        <Step key={data?.characteristic.length + 1}>
                            <StepLabel
                                onClick={() => setActiveStep(data?.characteristic.length + 1)}
                                sx={{ cursor: 'pointer' }}
                                // optional={
                                //         <Typography variant="caption">Adicione a descrição </Typography>
                                // }
                            >
                                Gerar Laudo  {data?.characteristic.length + 1}

                            </StepLabel>

                        </Step>
                    </Stepper>
                </Card>
            </Grid>
            <Grid item xs={12} md={9}>
                <Card>
                    <CardHeader
                        title={`${data?.number} - ${data?.characteristic[activeStep]?.name}`}
                        action={
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            {/*<Box>*/}
                            {/*    <CollectionsIcon fontSize="small" /> {`${data?.characteristic[activeStep]?.images.length}`}*/}
                            {/*</Box>*/}
                            <Button color={"secondary"} variant={"outlined"} size={"small"}>
                                <CollectionsIcon fontSize="small" />
                                {`${data?.characteristic[activeStep]?.images.length} image${data?.characteristic[activeStep]?.images.length > 1 ? 'ns' : 'm'}`}
                            </Button>

                        </Box>

                        }
                    />
                    <Divider sx={{ mb: 2}}/>
                    <CardContent sx={{ pl: 5, pr: 5,  }}>
                    {activeStep >= data?.characteristic.length  ? (
                        <Box>
                            <Typography>Todos os passos foram concluídos!</Typography>
                            <Button onClick={handleReset} sx={{ mt: 2 }}>
                                Reiniciar
                            </Button>
                        </Box>
                    ) : (
                        <Box>

                            <DropzoneImage
                                onUploadComplete={handleUploadComplete}
                                characteristicId={data?.characteristic[activeStep].id}
                                apiEndpoint="/property-inspection/characteristic/images/"
                            />
                            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                                <TextField
                                    id="outlined-multiline-flexible"


                                    placeholder={`Escreva sobre a vistoria}`}
                                    sx={{
                                        width: "90%",
                                        backgroundColor: "background.neutral",
                                        borderRadius: "10px",
                                        // Estilos para o placeholder devem estar aqui ou no InputProps
                                        "& .MuiInputBase-input::placeholder": {
                                            color: "gray",
                                            opacity: 1, // Importante para alguns navegadores
                                            paddingLeft: "1rem",
                                        },
                                    }}
                                    multiline
                                    value={data?.characteristic[activeStep]?.description}
                                    onChange={(event)=> {
                                        //setContent(event.target.value)
                                    }}
                                    maxRows={25}
                                    minRows={2}
                                    variant={"standard"}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                {/*<Tooltip title={`Clique para o assistente escrever a vistoria`}>*/}
                                                {/*    <IconButton*/}
                                                {/*        alt={"test"}*/}
                                                {/*        // Remova a propriedade 'variant' e 'loading' que não existem em IconButton*/}
                                                {/*        sx={{*/}
                                                {/*            //backgroundColor: "primary.main", // Use backgroundColor em vez de background*/}
                                                {/*            color: "white",*/}
                                                {/*            //border: 1,*/}
                                                {/*            //borderColor: "primary.main",*/}


                                                {/*        }}*/}
                                                {/*        //onClick={handleIconClick}*/}
                                                {/*        //disabled={true}*/}
                                                {/*    >*/}
                                                {/*        <CameraAlt color={"secondary"}  fontSize={"large"} sx={{*/}
                                                {/*            "&:hover": {*/}
                                                {/*                color: "primary.main", // Use backgroundColor aqui também*/}
                                                {/*            }*/}
                                                {/*        }} />*/}
                                                {/*    </IconButton>*/}
                                                {/*</Tooltip>*/}
                                                <Tooltip title={`Clique para o assistente escrever a vistoria`}>
                                                    <IconButton
                                                        alt={"test"}
                                                        // Remova a propriedade 'variant' e 'loading' que não existem em IconButton
                                                        sx={{
                                                            //backgroundColor: "primary.main", // Use backgroundColor em vez de background
                                                            color: "white",
                                                            //border: 1,
                                                            //borderColor: "primary.main",


                                                        }}
                                                        //onClick={handleIconClick}
                                                        disabled={data?.characteristic[activeStep].images.length >= 1 ? false : true}
                                                    >
                                                        <Assistant color={data?.characteristic[activeStep].images.length >= 1 ? "secondary" : "gray"}  fontSize={"large"} sx={{
                                                            "&:hover": {
                                                                color: "primary.main", // Use backgroundColor aqui também
                                                            },
                                                        }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </InputAdornment>
                                        ),
                                        disableUnderline: true,
                                        sx: {
                                            padding: "1rem",
                                            border: "none",
                                            outline: "none",
                                            // O seletor correto para o placeholder é este:
                                            "& input::placeholder, & textarea::placeholder": {
                                                color: "gray",
                                                opacity: 1,
                                                paddingLeft: "1rem"

                                            },
                                            "& .MuiInput-root:before": {
                                                borderBottom: "none",
                                            },
                                            "& .MuiInput-root:after": {
                                                borderBottom: "none",
                                            },
                                            "& .MuiInput-root:hover:not(.Mui-disabled):before": {
                                                borderBottom: "none",
                                            },
                                        },
                                    }}
                                />


                            </Box>
                            {/*{steps[activeStep]}*/}


                        </Box>
                    )}
                    </CardContent>
                    <Divider/>
                    <CardActions >

                            <Button
                                disabled={activeStep === 0}
                                onClick={handleBack}
                                sx={{ mr: 1 }}
                            >
                                Voltar
                            </Button>
                            <Box sx={{ flex: '1 1 auto' }} />
                            <Button variant={'text'} onClick={handleNext}>
                                {activeStep === data?.characteristic.length  ? 'Criar Laudo' : 'Próximo'}
                            </Button>

                    </CardActions>

                </Card>
            </Grid>
            {/*<Grid item xs={12} md={12}>*/}
            {/*    <Card sx={{mb:2}}>*/}
            {/*        <CardHeader sx={{ color:"default.main"}} title={`Dados Locatário`}*/}
            {/*            // action={*/}
            {/*            //     <Chip*/}
            {/*            //         label="Aberto"*/}
            {/*            //         color="info"*/}
            {/*            //         size="small"*/}
            {/*            //         variant="outlined"*/}
            {/*            //*/}
            {/*            //     />*/}
            {/*            // }*/}
            {/*        />*/}
            {/*        <Divider/>*/}
            {/*        <CardContent>*/}
            {/*            <Table>*/}
            {/*                <TableBody>*/}
            {/*                    <TableRow>*/}
            {/*                        <TableCell>*/}
            {/*                            <Typography><strong>Nome:</strong></Typography>*/}
            {/*                            <Typography>{data?.name}</Typography>*/}
            {/*                        </TableCell>*/}
            {/*                    </TableRow>*/}
            {/*                    <TableRow>*/}
            {/*                        <TableCell>*/}
            {/*                            <Typography><strong>CPF/CNPJ:</strong> </Typography>*/}
            {/*                            <Typography>{data?.cpf_or_cnpj}</Typography>*/}
            {/*                        </TableCell>*/}
            {/*                    </TableRow>*/}
            {/*                    <TableRow>*/}
            {/*                        <TableCell>*/}
            {/*                            <Typography><strong>Telefone:</strong> </Typography>*/}
            {/*                            <Typography>{data?.phone}</Typography>*/}
            {/*                        </TableCell>*/}
            {/*                    </TableRow>*/}
            {/*                    <TableRow>*/}
            {/*                        <TableCell>*/}
            {/*                            <Typography><strong>E-mail:</strong> </Typography>*/}
            {/*                            <Typography>{data?.email}</Typography>*/}
            {/*                        </TableCell>*/}
            {/*                    </TableRow>*/}
            {/*                    <TableRow>*/}
            {/*                        <TableCell>*/}
            {/*                            <Typography><strong>Criado em:</strong> </Typography>*/}
            {/*                            <Typography>{moment(data?.created_at).format("DD/MM/YYYY [às] HH:mm:ss")}</Typography>*/}
            {/*                        </TableCell>*/}
            {/*                    </TableRow>*/}
            {/*                    <TableRow>*/}
            {/*                        <TableCell>*/}
            {/*                            <Typography><strong>Endereço:</strong> </Typography>*/}
            {/*                            <Typography>{data?.full_address}</Typography>*/}
            {/*                        </TableCell>*/}
            {/*                    </TableRow>*/}
            {/*                </TableBody>*/}
            {/*            </Table>*/}

            {/*        </CardContent>*/}
            {/*    </Card>*/}

            {/*</Grid>*/}
            {/*/!* Dados da Vistoria *!/*/}
            {/*<Grid item xs={12} md={8}>*/}
            {/*    <Box>*/}
            {/*        <StreamViewer*/}
            {/*            open={open}*/}
            {/*            manual={manual}*/}
            {/*            onClose={() => setOpen(false)}/>*/}
            {/*    </Box>*/}

            {/*    {data?.characteristic.map(characteristic=>  (<Card sx={{ mb: 2 }}>*/}
            {/*        <CardHeader*/}
            {/*            title={`${characteristic.name}`}*/}
            {/*            action={*/}
            {/*                <Chip*/}
            {/*                    color="default"*/}
            {/*                    variant="outlined"*/}
            {/*                    size="small"*/}
            {/*                    label={*/}
            {/*                        <Box display="flex" alignItems="center" gap={0.5}>*/}
            {/*                            <CollectionsIcon fontSize="small" />*/}
            {/*                            {`${characteristic.images.length} image${characteristic.images.length > 1 ? 'ns' : 'm'}`}*/}
            {/*                        </Box>*/}
            {/*                    }*/}
            {/*                />*/}
            {/*            }*/}
            {/*        />*/}
            {/*        <Divider/>*/}
            {/*        <CardContent>*/}
            {/*            /!*<Box sx={{ mt:2}}>*!/*/}
            {/*            /!*    <ImageList sx={{ width: 'auto', height: 450 }} cols={6} rowHeight={75}>*!/*/}
            {/*            /!*    { characteristic.images?.map(image => (*!/*/}
            {/*            /!*        <ImageListItem key={image.image}>*!/*/}
            {/*            /!*            <img*!/*/}
            {/*            /!*                srcSet={image.image}*!/*/}
            {/*            /!*                src={image.image}*!/*/}
            {/*            /!*                alt={"test"}*!/*/}
            {/*            /!*                width={75}*!/*/}
            {/*            /!*                loading="lazy"*!/*/}
            {/*            /!*            />*!/*/}
            {/*            /!*        </ImageListItem>*!/*/}

            {/*            /!*        ))}*!/*/}
            {/*            /!*    </ImageList>*!/*/}
            {/*            /!*</Box>*!/*/}



            {/*            <Divider sx={{mt: 4, mb: 4}}/>*/}
            {/*            <Box sx={{display: "flex", justifyContent: "center"}}>*/}
            {/*                <Button variant="outlined"*/}

            {/*                        color={"secondary"}*/}
            {/*                        onClick={() => {*/}
            {/*                            setOpen(true)*/}
            {/*                            setManual(true)*/}
            {/*                        }}*/}
            {/*                        startIcon={<Create/>}*/}
            {/*                        sx={{marginTop: "1rem", mr: "1rem"}}>*/}
            {/*                    Criar descrição*/}
            {/*                </Button>*/}
            {/*                <Button variant="outlined"*/}

            {/*                        onClick={() => {*/}
            {/*                            setOpen(true)*/}
            {/*                            setManual(false)*/}
            {/*                        }}*/}
            {/*                        startIcon={<Assistant/>}*/}
            {/*                        sx={{marginTop: "1rem"}}>*/}
            {/*                    Criar descrição com IA*/}
            {/*                </Button>*/}

            {/*            </Box>*/}

            {/*        </CardContent>*/}
            {/*    </Card> ))}*/}


            {/*</Grid>*/}

            {/*/!* Imóvel *!/*/}
            {/*<Grid item xs={12} md={4}>*/}
            {/*    <Card sx={{mb:2}}>*/}
            {/*        <CardHeader sx={{ color:"default.main"}} title={`Dados Locatário`}*/}
            {/*                    // action={*/}
            {/*                    //     <Chip*/}
            {/*                    //         label="Aberto"*/}
            {/*                    //         color="info"*/}
            {/*                    //         size="small"*/}
            {/*                    //         variant="outlined"*/}
            {/*                    //*/}
            {/*                    //     />*/}
            {/*                    // }*/}
            {/*        />*/}
            {/*        <Divider/>*/}
            {/*        <CardContent>*/}
            {/*            <Table>*/}
            {/*                <TableBody>*/}
            {/*                    <TableRow>*/}
            {/*                        <TableCell>*/}
            {/*                            <Typography><strong>Nome:</strong></Typography>*/}
            {/*                            <Typography>{data?.name}</Typography>*/}
            {/*                        </TableCell>*/}
            {/*                    </TableRow>*/}
            {/*                    <TableRow>*/}
            {/*                        <TableCell>*/}
            {/*                            <Typography><strong>CPF/CNPJ:</strong> </Typography>*/}
            {/*                            <Typography>{data?.cpf_or_cnpj}</Typography>*/}
            {/*                        </TableCell>*/}
            {/*                    </TableRow>*/}
            {/*                    <TableRow>*/}
            {/*                        <TableCell>*/}
            {/*                            <Typography><strong>Telefone:</strong> </Typography>*/}
            {/*                            <Typography>{data?.phone}</Typography>*/}
            {/*                        </TableCell>*/}
            {/*                    </TableRow>*/}
            {/*                    <TableRow>*/}
            {/*                        <TableCell>*/}
            {/*                            <Typography><strong>E-mail:</strong> </Typography>*/}
            {/*                            <Typography>{data?.email}</Typography>*/}
            {/*                        </TableCell>*/}
            {/*                    </TableRow>*/}
            {/*                    <TableRow>*/}
            {/*                        <TableCell>*/}
            {/*                            <Typography><strong>Criado em:</strong> </Typography>*/}
            {/*                            <Typography>{moment(data?.created_at).format("DD/MM/YYYY [às] HH:mm:ss")}</Typography>*/}
            {/*                        </TableCell>*/}
            {/*                    </TableRow>*/}
            {/*                    <TableRow>*/}
            {/*                        <TableCell>*/}
            {/*                            <Typography><strong>Endereço:</strong> </Typography>*/}
            {/*                            <Typography>{data?.full_address}</Typography>*/}
            {/*                        </TableCell>*/}
            {/*                    </TableRow>*/}
            {/*                </TableBody>*/}
            {/*            </Table>*/}

            {/*        </CardContent>*/}
            {/*    </Card>*/}

            {/*</Grid>*/}

            {/* Contrato */}
            <Grid item xs={6}>

            </Grid>
        </Grid>
    );
};

export default InspectionDetails;